var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.74 3.48h4.14a3.06 3.06 0 0 1 3.12 3V18.5c0 1.66-1.4 3-3.12 3H15.5m0 0H6.12a3.06 3.06 0 0 1-3.12-3v-.2l.04-11.54V5.5c0-1.66 1.4-3 3.13-3h6.6m2.73 19a3.06 3.06 0 0 0 3.12-3V8.39M6.64 13.5h8.6m3.38-5.11h-4.5c-.75 0-1.36-.59-1.36-1.3V2.5m5.86 5.89L12.76 2.5M6.64 11V9.5m0 0V6h1.83c1 0 1.82.78 1.82 1.75S9.47 9.5 8.47 9.5H6.64Zm0 7.5h5.48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.717d575566136c83d155c73a74dd48d6.svg";
export { ForwardRef as ReactComponent };